var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MuiTabs from '@mui/material/Tabs';
import { Tab } from './Tab';
import { DropdownTab } from './DropdownTab';
var Tabs = function (props) {
    var dropdown = props.dropdown, tabs = props.tabs, value = props.value, onChange = props.onChange, restProps = __rest(props, ["dropdown", "tabs", "value", "onChange"]);
    var handleChange = function (event, newValue) {
        onChange(event, newValue);
    };
    return (_jsxs(MuiTabs, __assign({}, restProps, { value: false, onChange: handleChange }, { children: [tabs.map(function (tabListItem, idx) { return (_jsx(Tab, __assign({ isActive: tabListItem.value === value }, tabListItem), "tab_list_".concat(tabListItem.label).concat(idx))); }), dropdown && (_jsx(DropdownTab, { dropdown: dropdown, value: value, handleChange: handleChange }))] })));
};
export default Tabs;
